import { executePost } from "../ServiceMethods";
import { removeUserCredentials, userId } from "../LocalStorage";
import { toast } from "react-toastify";
import { SessionTimeout } from "../ErrorMessages";

export const VouchersApi = async (cb) => {
  try {
    const activeVouchers = await executePost("/myVouchers", {
      user_id: 18,
    });
    const activeVouchersData = activeVouchers.data ? activeVouchers.data : {};
    return activeVouchersData;
  } catch (error) {
    if (error.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};
